import { render, staticRenderFns } from "./fixed_price.vue?vue&type=template&id=152708ce&scoped=true&"
import script from "./fixed_price.vue?vue&type=script&lang=js&"
export * from "./fixed_price.vue?vue&type=script&lang=js&"
import style0 from "./fixed_price.vue?vue&type=style&index=0&id=152708ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152708ce",
  null
  
)

export default component.exports